import { memo } from "react";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { useImportSaga } from "@app/provider-network-imports/hooks";
import { SagaStateOptions } from "@app/provider-network-imports/state";

function nonMemoProviderNetworkMissingStepsAlert() {
  const { saga } = useImportSaga();
  const fields = saga.missingFields.map((fieldName) => <li key={fieldName}>{fieldName}</li>);

  return (
    <div className="d-flex flex-row justify-content-between pb-2">
      {saga.currentState === SagaStateOptions.ProviderValidationFailed &&
        <QESAlert type="danger" persist={true} collapseTitle="Critical exception! This network-version is missing required data and cannot be used.">
        The following required fields are empty:
          <ul>{fields}</ul>
        </QESAlert>}
    </div>
  );
}

export const ProviderNetworkMissingStepsAlert = memo(nonMemoProviderNetworkMissingStepsAlert);
